document.addEventListener("DOMContentLoaded", async function () {
  const jsonNode = document.getElementById("product-comparison-json");
  const productNode = document.getElementById("product-json");
  const container = document.getElementById("product-comparison-container");
  if (!jsonNode || !productNode || !container) return;

  const productComparisonJson = JSON.parse(jsonNode.textContent);
  const currentProductHandle = JSON.parse(productNode.textContent).current_product_handle;

  if (!productComparisonJson || productComparisonJson.length === 0) return;

  // Create table wrapper and table
  const tableWrapper = document.createElement("div");
  tableWrapper.className = "product-comparison__table-wrapper";

  const table = document.createElement("table");
  table.className = "product-comparison__table";

  // Create table header
  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");

  // Add "Features" header cell
  const featuresHeader = document.createElement("th");
  headerRow.appendChild(featuresHeader);

  // Reorder products to put current product first
  const reorderedProducts = [...productComparisonJson];
  const currentProductIndex = reorderedProducts.findIndex(
    (item) => item.handle === currentProductHandle
  );

  if (currentProductIndex !== -1) {
    const currentProduct = reorderedProducts.splice(currentProductIndex, 1)[0];
    reorderedProducts.unshift(currentProduct);
  }

  // Fetch additional product data for each product
  const productDetailsPromises = reorderedProducts.map(async (item) => {
    try {
      const response = await fetch(`/products/${item.handle}?view=comparison`);
      if (!response.ok) throw new Error(`Failed to fetch ${item.handle}`);
      const data = await response.json();
      return { ...item, details: data };
    } catch (error) {
      console.error(
        `Error fetching product details for ${item.handle}:`,
        error
      );
      return { ...item, details: null };
    }
  });

  // Wait for all product details to be fetched
  const productsWithDetails = await Promise.all(productDetailsPromises);

  // Add product header cells
  productsWithDetails.forEach((item) => {
    const productHeader = document.createElement("th");
    productHeader.className = "product-comparison__product-header";
    if (item.handle === currentProductHandle) {
      productHeader.classList.add("product-comparison__current-product");
    }

    // Product image and title
    const productContent = document.createElement("div");

    // 1. Create image element if we have details (first)
    if (item.details && item.details.featured_image) {
      const imgLink = document.createElement("a");
      imgLink.href = "/products/" + item.handle;

      const img = document.createElement("img");
      img.src = item.details.featured_image;
      img.alt = item.details.title || item.handle;
      img.className = "product-comparison__product-image";

      imgLink.appendChild(img);
      productContent.appendChild(imgLink);
    }

    // 2. Create link with title (second)
    const link = document.createElement("a");
    link.href = "/products/" + item.handle;
    link.textContent = (item.details && item.details.title) || item.title || item.handle;
    link.className = "product-comparison__product-title";

    // Add current label if needed
    if (item.handle === currentProductHandle) {
      const currentLabel = document.createElement("span");
      currentLabel.className = "product-comparison__current-label";
      currentLabel.textContent = "Current product";
      link.appendChild(currentLabel);
    }

    productContent.appendChild(link);

    // 3. Add price information (third)
    if (item.details) {
      const priceDiv = document.createElement("div");
      priceDiv.className = "product-comparison__price-container";

      if (item.details.compare_at_price) {
        const comparePrice = document.createElement("span");
        comparePrice.className = "product-comparison__compare-price";
        comparePrice.textContent = item.details.compare_at_price;
        priceDiv.appendChild(comparePrice);
      }

      const price = document.createElement("span");
      price.className = "product-comparison__price";
      price.textContent = item.details.price || "";
      priceDiv.appendChild(price);

      productContent.appendChild(priceDiv);
    }

    productHeader.appendChild(productContent);
    headerRow.appendChild(productHeader);
  });

  thead.appendChild(headerRow);
  table.appendChild(thead);

  // Create table body
  const tbody = document.createElement("tbody");

  // Get properties from the first item (excluding 'handle', 'title', and 'details')
  const firstItem = productsWithDetails[0];
  const properties = Object.keys(firstItem).filter(
    (key) => key !== "handle" && key !== "title" && key !== "details"
  );

  // Create rows for each property
  properties.forEach((property) => {
    const row = document.createElement("tr");

    // Add property name cell
    const propertyCell = document.createElement("td");
    propertyCell.className = "product-comparison__feature-name";
    propertyCell.textContent = property;
    row.appendChild(propertyCell);

    // Add value cells for each product
    productsWithDetails.forEach((item) => {
      const valueCell = document.createElement("td");
      if (item.handle === currentProductHandle) {
        valueCell.classList.add("product-comparison__current-product");
      }
      valueCell.textContent = item[property] || "-";
      row.appendChild(valueCell);
    });

    tbody.appendChild(row);
  });

  // Add a row for the "View Product" buttons at the bottom of the table
  const buttonRow = document.createElement("tr");

  // Add empty cell for the feature name column
  const emptyCell = document.createElement("td");
  emptyCell.className = "product-comparison__feature-name";
  buttonRow.appendChild(emptyCell);

  // Add button cells for each product
  productsWithDetails.forEach((item) => {
    const buttonCell = document.createElement("td");
    if (item.handle === currentProductHandle) {
      buttonCell.classList.add("product-comparison__current-product");
      // No button for current product
      buttonCell.textContent = "";
    } else {
      const viewProductButton = document.createElement("a");
      viewProductButton.href = "/products/" + item.handle;
      viewProductButton.className = "product-comparison__view-button button";
      viewProductButton.textContent = "View Product";
      buttonCell.appendChild(viewProductButton);
    }

    buttonRow.appendChild(buttonCell);
  });

  tbody.appendChild(buttonRow);

  table.appendChild(tbody);
  tableWrapper.appendChild(table);
  container.appendChild(tableWrapper);
});
